import transfer from './transfer'
import options from './options'
import feedback from './feedback'
import images from './images'
import carousel from './carousel'
import epa from './epa'

const actions = {
  transfer,
  options,
  feedback,
  images,
  carousel,
  epa
}

export default actions
